import Vue from 'vue'
import Vuex from 'vuex'
import verifier from "./modules/verifier";

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        verifier
    }
});
export default store;
